import type { GridLayer, Map as LeafletMap } from "leaflet";
import { useEffect, useRef, type RefObject } from "react";
import {
  createProtomapsPrintAdapter,
  type ProtomapsPrintAdapterOptions,
} from "@/features/map/utils/protomapsPrintAdapter";
import { registerPrintLayerAdapter } from "@/features/map/utils/printLayerAdapterRegistry";

interface UseProtomapsPrintAdapterOptions
  extends Omit<ProtomapsPrintAdapterOptions, "normalLayer"> {
  map: LeafletMap;
  normalLayerRef: RefObject<GridLayer>;
}

export const useProtomapsPrintAdapter = ({
  map,
  enabled,
  normalLayerRef,
  createPrintLayer,
}: UseProtomapsPrintAdapterOptions): void => {
  const enabledRef = useRef(enabled);
  const createPrintLayerRef = useRef(createPrintLayer);
  enabledRef.current = enabled;
  createPrintLayerRef.current = createPrintLayer;

  useEffect(() => {
    const registration = { active: true };
    const unregister = registerPrintLayerAdapter(map, () =>
      createProtomapsPrintAdapter({
        map,
        enabled: enabledRef.current,
        normalLayer: normalLayerRef.current,
        createPrintLayer: createPrintLayerRef.current,
        isRegistrationActive: () => registration.active,
      })
    );

    return () => {
      registration.active = false;
      unregister();
    };
  }, [map, normalLayerRef]);
};
